import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" className="proj_card_img" src={props.imgPath} alt="card-img" />
      <Card.Body className="proj_Card_Body">
        <Card.Title style ={{color:"cyan"}}>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify"}} className="project_desc">
          {props.description}
        </Card.Text>

        <div className="bottom-right">
        {props.ghLink ? (
            <Button className="proj_btn-group " variant="primary" href={props.ghLink} target="_blank">
                <BsGithub /> &nbsp;
                {props.isBlog ? "Blog" : "GitHub"}
            </Button>
        ) : null}


        {props.View ? (
          <Button className="proj_btn-group " variant="primary" href={props.View} target="_blank">
              <BsGithub /> &nbsp;
              {props.isView ? "View Project" : "View"}
          </Button>
      ) : null}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && props.demoLink && (
            <Button
                variant="primary"
                href={props.demoLink}
                target="_blank"
                style={{ marginLeft: "10px" }}
            >
                <CgWebsite /> &nbsp;
                {"Demo"}
            </Button>
        )}
    </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
